@switch (dependency) {
  <!-- Show icon if ship's entry to first berth is dependant in some way on another ship -->
  @case ('EXCHANGE') {
    <span class="mx-2"
          [title]="thisShipName + ' exchanges with ' + (otherShipName ? otherShipName : '...')">
      <span class="fa fa-fw fa-ship me-1"></span>
      <span class="fa fa-fw fa-exchange-alt me-1"></span>
      <span class="fa fa-fw fa-ship me-1"></span>
    </span>
  }
  @case ('ENTRY_AFTER') {
    <span class="mx-2"
          [title]="thisShipName + ' enters after ' + (otherShipName ? otherShipName : '...')">
      <span class="fa fa-fw fa-ship me-1"></span>
      <span class="fa fa-fw fa-long-arrow-alt-right me-1"></span>
      <span class="fa fa-fw fa-ship me-1"></span>
    </span>
  }
}
